export default __webpack_public_path__ + "static/media/6.4c3d2268.jpeg";